<script setup>
import GlIcon from "~/components/gitlab/GlIcon.vue";

const { disabled, endCursor, hasNextPage, hasPreviousPage, nextText, prevText, startCursor } = defineProps({
  disabled: { default: false, type: Boolean },
  endCursor: { default: null, type: String },
  hasNextPage: { default: false, type: Boolean },
  hasPreviousPage: { default: false, type: Boolean },
  nextText: { default: "Next", type: String },
  prevText: { default: "Previous", type: String },
  startCursor: { default: null, type: String }
});

const emit = defineEmits(["prev", "next"]);

function handlePrev() {
  if (!disabled && hasPreviousPage) {
    emit("prev", startCursor);
  }
}

function handleNext() {
  if (!disabled && hasNextPage) {
    emit("next", endCursor);
  }
}
</script>

<template>
  <nav v-if="hasPreviousPage || hasNextPage" class="gl-pagination flex justify-center" aria-label="Pagination">
    <div class="gl-keyset-pagination inline-flex gap-3">
      <button
        :disabled="disabled || !hasPreviousPage"
        data-testid="prevButton"
        class="gl-keyset-pagination-btn inline-flex items-center gap-2 rounded-md border border-[var(--gl-border-color-default)] bg-[var(--gl-background-color-default)] px-3 py-2 text-sm text-[var(--gl-text-color-default)] hover:bg-[var(--gl-background-color-subtle)] disabled:cursor-not-allowed disabled:opacity-50"
        @click="handlePrev"
      >
        <slot name="previous-button-content">
          <GlIcon name="chevron-lg-left" :size="16" />
          {{ prevText }}
        </slot>
      </button>
      <button
        :disabled="disabled || !hasNextPage"
        data-testid="nextButton"
        class="gl-keyset-pagination-btn inline-flex items-center gap-2 rounded-md border border-[var(--gl-border-color-default)] bg-[var(--gl-background-color-default)] px-3 py-2 text-sm text-[var(--gl-text-color-default)] hover:bg-[var(--gl-background-color-subtle)] disabled:cursor-not-allowed disabled:opacity-50"
        @click="handleNext"
      >
        <slot name="next-button-content">
          {{ nextText }}
          <GlIcon name="chevron-lg-right" :size="16" />
        </slot>
      </button>
    </div>
  </nav>
</template>
